import CLIENT from '../../../store/actions/CLIENT';
import { SEND_ERROR_SUCCESS, SEND_ERROR_ERROR } from './types';

export const SendError = (payload) => async (dispatch, getState) => {
  try {
    const response = await CLIENT({
      url: '/error',
      state: getState(),
      body: {
        error: payload.error,
        title: payload.title,
      },
    });
    return dispatch({
      type: SEND_ERROR_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    return dispatch({
      type: SEND_ERROR_ERROR,
      payload: error,
    });
  }
};
